import { render, staticRenderFns } from "./efaturadip.vue?vue&type=template&id=2008156e"
import script from "./efaturadip.vue?vue&type=script&lang=js"
export * from "./efaturadip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports